import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { first, isEmpty } from 'lodash';
import TableRow from 'components/tables/tableRow';
import TableCell from 'components/tables/tableCell';
import Checkbox from 'components/forms/Checkbox';
import MessageOutlineIcon from 'mdi-react/MessageOutlineIcon';
import {
  getErrorText, getFullName,
  getOutletList, getReplyStatus,
} from 'utils/contact';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import DotsVerticalIcon from 'mdi-react/DotsVerticalIcon';
import AlertOutlineIcon from 'mdi-react/AlertOutlineIcon';
import ReplyStatusBadge from 'components/Inbox/InboxList/ReplyStatusBadge';

import MessagesPopover from '../../MessagesPopover';
import ActionsPopover from './ActionsPopover';

class ContactRow extends Component {
  renderCurrentSequenceReply = contact => (
    <TableCell className="rectangle-cell rectangle-cell--no-hover">
      {!isEmpty(contact.replies) &&
        <ReplyStatusBadge status={getReplyStatus(first(contact.replies)).statusCode} />
      }
    </TableCell>
  )

  renderAllReplies = (contact) => {
    const { parentComponentId } = this.props;
    const popoversReplyId = `popover-replies-${parentComponentId}-${contact.id}`;
    return (
      <TableCell className="rectangle-cell">
        {!isEmpty(contact.replies) && (
          <React.Fragment>
            <div
              className="rectangle-cell__item"
              role="button"
              id={popoversReplyId}
            >
              <MessageOutlineIcon />
              ({contact.replies.length})
            </div>
            <MessagesPopover uuid={parentComponentId} seqContact={contact} />
          </React.Fragment>
        )}
      </TableCell>
    );
  }

  renderContactErrors = (contact, errors) => {
    const { parentComponentId } = this.props;
    const popoversErrorId = `popover-errors--${parentComponentId}-${contact.id}`;

    return (
      <React.Fragment>
        <div
          role="button"
          className="rectangle-cell__item bg-warning"
          id={popoversErrorId}
        >
          <AlertOutlineIcon />
          ({errors.length})
        </div>
        <UncontrolledPopover
          className="zindex-modal sequence-create__contacts-ready__popover"
          trigger="legacy"
          placement="auto"
          target={popoversErrorId}
          delay={0}
          role="tooltip"
        >
          <PopoverBody>
            {errors.map((err, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={i}>
                {getErrorText(err)}
                {i + 1 !== errors.length && <hr className="mtb-25" />}
              </React.Fragment>
            ))}
          </PopoverBody>
        </UncontrolledPopover>
      </React.Fragment>
    );
  };

  renderSteps = contact => (
    <TableCell>
      <div className="pill-steps">
        <span>{contact.current_step}</span>
        <span>{contact.total_steps}</span>
      </div>
    </TableCell>
  );

  renderPopoverActions = (contact) => {
    const { parentComponentId, toggleModal } = this.props;
    const popoversActionId = `popover-actions-${parentComponentId}-${contact.id}`;
    return (
      <React.Fragment>
        <div role="button" id={popoversActionId}>
          <DotsVerticalIcon />
        </div>
        <ActionsPopover target={popoversActionId} toggleModal={toggleModal} seqContact={contact} />
      </React.Fragment>
    );
  }
  render() {
    const {
      contact,
      isSelected,
      showContactReplyForCurrentSequence,
      showSteps,
    } = this.props;

    return (
      <TableRow
        role="checkbox"
        onClick={event => this.props.handleSelectClick(event, contact.id)}
        // prevent text selection during shift + click
        onMouseDown={event => event.shiftKey && event.preventDefault()}
        aria-checked={isSelected}
        tabIndex={-1}
        key={contact.id}
        selected={isSelected}
      >
        <TableCell padding="checkbox">
          <Checkbox checked={isSelected} />
        </TableCell>
        <TableCell>{getFullName(contact)}</TableCell>
        <TableCell>{contact.email}</TableCell>
        <TableCell>{getOutletList(contact.outlets)}</TableCell>
        <TableCell>{contact.subject}</TableCell>
        {showSteps && this.renderSteps(contact)}
        {showContactReplyForCurrentSequence ?
          this.renderCurrentSequenceReply(contact) : this.renderAllReplies(contact)}
        <TableCell className="rectangle-cell">
          {!isEmpty(contact.errors) ? this.renderContactErrors(contact, contact.errors)
            : <div className="rectangle-cell--always-space" />}
        </TableCell>
        <TableCell className="dots-actions text-right">
          {this.renderPopoverActions(contact)}
        </TableCell>
      </TableRow>
    );
  }
}

ContactRow.propTypes = {
  contact: PropTypes.shape({}).isRequired,
  isSelected: PropTypes.bool.isRequired,
  parentComponentId: PropTypes.string.isRequired,
  handleSelectClick: PropTypes.func.isRequired,
  showSteps: PropTypes.bool,
  showContactReplyForCurrentSequence: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  sequence: PropTypes.shape({}).isRequired,
};

ContactRow.defaultProps = {
  showSteps: false,
  showContactReplyForCurrentSequence: false,
};

export default ContactRow;
